export const formatPriceWithCurrency = (
  amount: number,
  currency: string,
  language?: string,
  quantity = 1
) =>
  ((amount * quantity) / 100).toLocaleString(language || 'fr', {
    minimumFractionDigits: amount === 0 ? 0 : 2,
    style: 'currency',
    currency,
    currencyDisplay: 'symbol'
  })
